<template>
  <div class="cites">
    <div
      class="text-left"
      style="margin-bottom: 40px; color: rgba(218, 10, 10, 0.7)"
    >
      说明：当前学者的综合能力分析数据均来源于该学者的引文报告，如果想了解更多维度数据，请点击上方引文报告自行下载查看。
    </div>
    <div class="flex">
      <div style="width: 60%" v-loading="domainRankLoading">
        <div class="flex items-center justify-start">领域排名</div>
        <div class="content-text" style="margin-top: 20px">
          {{ domainRankSummary }}
        </div>
        <div>
          <el-table
            :header-cell-style="{
              background: '#0751AA',
              borderBottom: '2px solid #EAE9E9',
              textAlign: 'left',
              color: '#fff',
            }"
            border
            :data="domainRankData"
            style="margin-top: 26px"
          >
            <el-table-column prop="domainName" label="荣誉"></el-table-column>
            <el-table-column prop="sumScholar" label="总人数"></el-table-column>
            <el-table-column
              prop="scholarRank"
              label="当前学者排名"
            ></el-table-column>
            <el-table-column
              prop="percentage"
              label="超越学者占比"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <div
        style="width: 40%; margin-left: 60px"
        v-loading="pubStatisticLoading"
      >
        <div class="flex items-center justify-start">论文分析</div>
        <div class="content-text" style="margin-top: 20px">
          {{ pubStatisticSummary }}
        </div>
        <pub-statistic-chart
          :series-data="pubStatisticData"
          :num="pubStatisticNum"
          v-if="pubStatisticData && pubStatisticData.length"
        />
        <el-empty v-else />
      </div>
    </div>
    <div style="margin-top: 60px" class="flex items-center justify-start">
      引文分析
    </div>
    <p
      class="content-text"
      style="margin-top: 20px; white-space: pre-line; line-height: 1.5"
    >
      {{ citedStatisticSummary }}
    </p>
    <talent-cites-bar ref="citesBar" :data="citesPerYear" :bt-active="1" />
    <div class="divider-line"></div>
    <div class="flex items-center justify-start">知名学者引用分析</div>
    <div class="table-view" v-loading="citesLoading">
      <!--      <div class="content-text" style="margin-bottom: 20px">-->
      <!--        {{ content }}-->
      <!--      </div>-->
      <el-table
        :header-cell-style="{
          background: '#0751AA',
          borderBottom: '2px solid #EAE9E9',
          textAlign: 'left',
          color: '#fff',
        }"
        border
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column prop="name" label="荣誉" width="240">
          <template slot-scope="scope">
            <p>{{ scope.row.name }}</p>
          </template>
        </el-table-column>

        <el-table-column prop="authors" label="学者">
          <template slot-scope="scope">
            <div class="flex flex-wrap" style="padding-left: 20px">
              <p
                class="left-title"
                v-for="(item, index) in scope.row.authors"
                :key="index"
              >
                {{ item.name + ';' }}
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import TalentCitesBar from '@/views/details/comps/talentCitesBar.vue';
import {
  citedStatisticApi,
  domainRankApi,
  getScholarCitedAuthorTagsApi,
  pubStatisticApi,
} from '@/api/details';
import PubStatisticChart from '@/views/details/comps/pubStatisticChart.vue';

export default {
  name: 'talentCites',
  components: { PubStatisticChart, TalentCitesBar },
  props: ['scholarId', 'citesPerYear'],
  data() {
    return {
      tableData: [],
      content: '',
      highXData: [],
      highSeriesData: [],
      pubStatisticData: [],
      domainRankData: [],
      pubStatisticSummary: '',
      domainRankSummary: '',
      citedStatisticSummary: '',
      pubStatisticNum: 0,
      pubStatisticLoading: false,
      domainRankLoading: false,
      citesLoading: false,
    };
  },
  watch: {
    scholarId: {
      handler() {
        if (this.scholarId) {
          this.init();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  methods: {
    init() {
      this.getScholarCitedAuthor();
      this.getScholarCitedAuthorTags();
      this.getCitedStatistic();
      this.getPubStatistic();
      this.getDomainRank();
    },
    getCitedStatistic() {
      citedStatisticApi(this.scholarId).then((res) => {
        if (res.code == 200) {
          this.citedStatisticSummary = res.data;
        }
      });
    },

    getDomainRank() {
      this.domainRankLoading = true;
      domainRankApi(this.scholarId)
        .then((res) => {
          this.domainRankLoading = false;
          if (res.code == 200) {
            this.domainRankSummary = res.data.summary;
            this.domainRankData = res.data.domainRanks;
          }
        })
        .catch(() => {
          this.domainRankLoading = false;
        });
    },
    getPubStatistic() {
      this.pubStatisticLoading = true;
      pubStatisticApi(this.scholarId)
        .then((res) => {
          this.pubStatisticLoading = false;
          if (res.code == 200) {
            this.pubStatisticNum = res.data.pubSum;
            this.pubStatisticSummary = res.data.summary;
            this.pubStatisticData = res.data.tagRates;
          }
        })
        .catch(() => {
          this.pubStatisticLoading = false;
        });
    },
    getScholarCitedAuthor() {
      // getHighCitedSummaryApi(this.scholarId).then((res) => {
      //   if (res.code == 200) {
      //     this.content = res.data;
      //   }
      // });
    },
    getScholarCitedAuthorTags() {
      this.citesLoading = true;
      getScholarCitedAuthorTagsApi(this.scholarId)
        .then((res) => {
          if (res.code == 200) {
            let data = res.data.tagAggs;
            let key = Object.keys(data);
            this.tableData = [];
            key.map((item) => {
              this.tableData.push({
                name: item,
                total: data[item].total,
                authors: data[item].authors,
              });
            });
          }
          this.citesLoading = false;
        })
        .catch(() => {
          this.citesLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.table {
  table-layout: fixed; /* 固定布局，列宽不会自动调整 */
}

.cites {
  border-radius: 6px;
  border: 1px solid #eeeeee;
  padding: 26px 30px;
  margin-top: 15px;

  .item-title-left {
    width: 6px;
    height: 6px;
    background: #1241C9;
    border-radius: 50%;
    margin-right: 8px;
    font-size: 16px;
    color: #333333;
  }

  .divider-line {
    margin: 16px 0 23px;
    border-bottom: 1px dashed #eeeeee;
  }

  .table-view {
    margin-top: 19px;
  }

  .content-text {
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 22px;
    text-align: start;
  }
}

.items-center {
  font-weight: bold;
}
</style>
